<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.editAdmin") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs">
          <div class="row">
            <ValidationProvider
              name="الصورة"
              rules="required"
              v-slot="{ errors }"
              class="col-12"
            >
              <base-image-upload-input
                col="12"
                identifier="admin_image"
                :preSelectedImage="data.image.path"
                :placeholder="$t('PLACEHOLDERS.personalImage')"
                @selectImage="selectImage"
                :errors="errors[0]"
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.name')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.name')"
                v-model.trim="data.name"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.email')"
              rules="required|email"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.email')"
                v-model.trim="data.email"
                @input="emailServerError = null"
                :errors="errors[0] || emailServerError"
                required
              />
            </ValidationProvider>

            <ValidationProvider
              :name="$t('PLACEHOLDERS.phone')"
              class="col-lg-6"
            >
              <base-phone-input
                col="12"
                v-if="country_code"
                required
                ref="phoneInput"
                :Country_code="country_code"
                v-model="data.phone"
                @dialCode="dialCode"
                @hasError="hasError"
                :errors="mobileServerError"
                :placeholder="$t('PLACEHOLDERS.phone')"
                :defaultCountry="defaultCountry"
              />
            </ValidationProvider>

            <!-- ✅ Roles Select -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.role')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                v-if="roles"
                col="12"
                :optionsList="roles"
                :placeholder="$t('PLACEHOLDERS.role')"
                v-model="data.role"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- ✅ Switch for enabling password edit -->
            <div class="input_wrapper switch_wrapper my-5 col-12">
              <v-switch
                color="green"
                :label="$t('PLACEHOLDERS.editPassword')"
                v-model="data.enableEditPassword"
                hide-details
              ></v-switch>
            </div>

            <Transition name="fadeInUp" mode="out-in">
              <div class="col-12" v-if="data.enableEditPassword">
                <div class="row">
                  <ValidationProvider
                    :name="$t('PLACEHOLDERS.password')"
                    rules="required|custom_password"
                    v-slot="{ errors }"
                    class="col-lg-6"
                  >
                    <base-input
                      col="12"
                      type="password"
                      :placeholder="$t('PLACEHOLDERS.password')"
                      v-model.trim="data.password"
                      :errors="errors[0]"
                      required
                    />
                  </ValidationProvider>

                  <ValidationProvider
                    :name="$t('PLACEHOLDERS.confirmPassword')"
                    :rules="{
                      required: true,
                      password_match: { target: data.password },
                    }"
                    v-slot="{ errors }"
                    class="col-lg-6"
                  >
                    <base-input
                      col="12"
                      type="password"
                      :placeholder="$t('PLACEHOLDERS.confirmPassword')"
                      v-model.trim="data.passwordConfirmation"
                      :errors="errors[0]"
                      required
                    />
                  </ValidationProvider>
                </div>
              </div>
            </Transition>

            <!-- ✅ Submit Button -->
            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import CountryCodes from "../../../assets/CountryCodes.json";

export default {
  name: "EditAdmin",

  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      country_code: null,
      isWaitingRequest: false,

      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        email: null,
        dial_code: null,
        phone: null,
        role: null,
        whatsApp: null,
        areas: null,
        type: null,
        enableEditPassword: false,
        password: null,
        passwordConfirmation: null,
        active: true,
      },
      defaultCountry: null,
      allAreas: [],
      roles: [],
      emailServerError: null,
      mobileServerError: null,
      nameServerError: null,
    };
  },

  computed: {
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
  },

  methods: {
    hasError(data) {
      this.data.hasError = data;
    },
    dialCode(data) {
      this.data.dial_code = data.dialCode;
    },
    async getRoles() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: "roles?page=0&limit=0&status=1&ignorePermissionCheck=1",
        });

        this.roles = res.data.data;
        console.log(this.roles);
      } catch (error) {
        this.loading = false;
        console.log(error.response.data.message);
      }
    },
    // Start:: Get Data To Show
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `admins/${this.id}`,
        });
        this.data.image.path = res.data.data.Admin?.avatar;
        const code = res?.data?.data?.Admin?.country_code;

        this.country_code = code && code.trim() !== "" ? Number(code) : 966;

        if (this.country_code) {
          const country = CountryCodes?.find(
            (c) => c?.country_code == this.country_code
          );
          this.defaultCountry = country ? country.alpha2 : "SA";
        }
        this.data.name = res.data.data.Admin.name;
        this.data.email = res.data.data.Admin.email;
        this.data.phone = res.data.data.Admin.mobile;
        this.data.role = res.data.data.Admin.role_obj;
        this.data.active = res.data.data.Admin.is_active;
        this.data.numberOfVisits = res.data.data.Admin.login_count;
        this.data.lastVisit = res.data.data.Admin.last_login;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    focusInput() {
      this.$refs.phoneInput?.focus();
    },
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },

    validateFormInputs() {
      this.focusInput();
      this.isWaitingRequest = true;

      if (!this.data.name) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name"));
        return;
      } else if (!this.data.email) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.email"));
        return;
      } else if (!this.data.phone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mobileNumber"));
        return;
      } else if (!this.data.role) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.role"));
        return;
      } else if (this.data.enableEditPassword) {
        if (!this.data.password) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.password"));
          return;
        } else if (this.data.password.length < 6) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.passwordLength"));
          return;
        } else if (!this.data.passwordConfirmation) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.password"));
          return;
        } else if (this.data.passwordConfirmation.length < 6) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.passwordLength"));
          return;
        } else if (this.data.password != this.data.passwordConfirmation) {
          this.isWaitingRequest = false;
          this.$message.error(this.$t("VALIDATION.notEqualPasswords"));
          return;
        } else {
          this.submitForm();
        }
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs
    setServerError(field, error) {
      this[`${field}ServerError`] =
        error?.response?.data?.errors?.[field]?.[0] || null;
    },
    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("_method", "PUT");

      if (this.data.image.file != null) {
        REQUEST_DATA.append("avatar", this.data.image?.file);
      }
      REQUEST_DATA.append("name", this.data.name);
      REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("mobile", this.data.phone);
      REQUEST_DATA.append("alpha2", this.data.dial_code);

      if (this.data.role) {
        REQUEST_DATA.append("role", this.data.role?.id);
      }
      if (this.data.password) {
        REQUEST_DATA.append("password", this.data.password);
      }

      if (this.data.passwordConfirmation) {
        REQUEST_DATA.append(
          "password_confirmation",
          this.data.passwordConfirmation
        );
      }
      REQUEST_DATA.append("is_active", this.data.active ? 1 : 0);

      try {
        await this.$axios({
          method: "POST",
          url: `admins/${this.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/admins/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.setServerError("email", error);
        this.setServerError("mobile", error);
        this.setServerError("name", error);
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    // Start:: Fire Methods
    this.getRoles();
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
